/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { CSSProperties, useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom/client";
import cn from "classnames";
import sass from "./comment.module.sass";
import { findNode, isEmpty } from "helpers";
import TextArea from "../../components-new/Textarea";

interface ICommentItemJSX {
	children: string;
	styles: CSSProperties;
	remove: () => void;
	save: (str: string) => void;
	isAdmin: boolean;
}

const CommentItemJSX: React.FC<ICommentItemJSX> = ({ children, isAdmin, save, styles, remove }) => {
	const initialProps = useRef(styles);
	const [state, setState] = useState("");
	const [active, setActive] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const ref = useRef<HTMLDivElement | null>(null);
	const widthWindow = useMemo(() => {
		return Math.max(
			document.body.scrollWidth,
			document.documentElement.scrollWidth,
			document.body.offsetWidth,
			document.documentElement.offsetWidth,
			document.documentElement.clientWidth,
		);
		//eslint-disable-next-line
	}, [document]);
	const [displayStyle, setDisplayStyle] = useState("grid");

	const isFirstLoad = useRef(true);

	useEffect(() => {
		if (ref.current) {
			const rootEl = document.querySelector("#root");
			if (initialProps.current.top) {
				const top = +initialProps.current.top;
				const mainEl =
					(rootEl?.querySelector("#root > main") as HTMLElement) ||
					(rootEl?.querySelector(".step-wrapper") as HTMLElement);
				if (mainEl?.offsetTop - 15 >= top) {
					setDisplayStyle("none");
				} else {
					setDisplayStyle("grid");
				}
			}
		}
		//eslint-disable-next-line
	}, [initialProps.current]);

	const changeIsEdit = useCallback(() => {
		const flag = !isEdit;
		if (!flag) save(state);
		setIsEdit(flag);
		//eslint-disable-next-line
	}, [state, isEdit]);

	useEffect(() => {
		setState(children);
	}, [children]);

	const calculate = useCallback(
		(style: CSSProperties = {}) => {
			if (ref.current) {
				const element = ref.current;
				const { x, width, top } = element.getBoundingClientRect();
				if (isEmpty(style)) {
					if (x < 0) {
						element.style.translate = Math.abs(x) + 10 + "px";
					}
					if (x + width > widthWindow) {
						element.style.translate = widthWindow - (width + x) - 10 + "px";
					}
					if (top < 0) {
						let str: string;
						if (x < 0) {
							str = Math.abs(x) + 10 + "px";
						} else {
							str = "0px";
						}
						element.style.translate = `${str} ${Math.abs(top) + 10}px`;
					}
				} else {
					element.style.translate = "0 0";
					element.style.left = style.left + "px";
					element.style.top = style.top + "px";
				}
			}
		},
		//eslint-disable-next-line
		[ref.current],
	);

	useEffect(() => {
		if (isFirstLoad.current) isFirstLoad.current = false;
	}, []);

	useEffect(() => {
		if (active) {
			setTimeout(() => {
				calculate();
			}, 250);
		} else {
			calculate(initialProps.current);
		}
		//eslint-disable-next-line
	}, [active]);
	return (
		<div
			data-comment={true}
			ref={ref}
			// style={{ left: initialProps.current.left, top: initialProps.current.top }}
			style={{ left: initialProps.current.left, top: initialProps.current.top, display: displayStyle }}
			className={cn(sass.container, active ? sass["container-active"] : sass["container-disable"])}>
			<div
				onMouseDown={() => {
					setActive((prevState) => !prevState);
				}}
				className={sass["comment-icon"]}></div>
			{active && (
				<>
					<div className={sass.header_comment}>
						<div className={sass.icons}>
							{isAdmin && (
								<>
									<div onMouseDown={changeIsEdit} className={sass.icon}>
										<div className={cn(sass["icon-edit"])} />
									</div>
									<div onMouseDown={remove} className={sass.icon}>
										<div className={cn(sass["icon-remove"])} />
									</div>
								</>
							)}
							<div className={sass.icon}>
								<div onMouseDown={() => setActive(false)} className={cn(sass["icon-close"])} />
							</div>
						</div>
					</div>
					<div className={sass.content_comment}>
						{isEdit ? (
							<TextArea
								rows={10}
								autoFocus
								onFocus={(e) => {
									e.target.select();
								}}
								value={state}
								onChange={({ target }) => {
									setState(target.value);
								}}
							/>
						) : state ? (
							<pre>{state}</pre>
						) : (
							<span className={sass.emptyText}>Оставьте комментарий</span>
						)}
					</div>
				</>
			)}
		</div>
	);
};

class Comment {
	private id = "wrapper-comment";
	private root: any = null;
	private container: HTMLElement | null = null;
	private comments: any[] = [];

	constructor() {
		this.render = this.render.bind(this);
	}

	private createJSX() {
		this.root.render(
			<>
				{this.comments.map((_) => (
					<CommentItemJSX
						isAdmin={_.isAdmin}
						save={(str: string) => _.saveItem(str)}
						remove={() => {
							_.removeItem();
							this.removeItem(_.index);
						}}
						styles={_.style}
						key={_.index}>
						{_.block}
					</CommentItemJSX>
				))}
			</>,
		);
	}

	private init() {
		if (!this.container) {
			this.container = document.getElementById(this.id);
			if (!this.container) {
				const wrapper = document.createElement("div");
				wrapper.id = this.id;
				// if (position) {
				// wrapper.style.cssText = positionData[Position[position]];
				// }
				document.body.append(wrapper);
				this.container = document.getElementById(this.id);
			}
		}

		if (!this.root) {
			this.root = ReactDOM.createRoot(this.container!);
		}
	}

	private removeItem(index: number) {
		this.comments = this.comments.filter((_) => _.index !== index);
		if (!this.comments.length) {
			this.container?.remove();
			this.container = null;
			this.root = null;
		} else {
			this.createJSX();
		}
	}
	removeAll() {
		this.comments = [];
		this.container?.remove();
		this.container = null;
		this.root = null;
	}
	private createSnack(
		link: string,
		child: any,
		url: string,
		remove: (item: any) => void,
		save: (item: any) => void,
		isAdmin: boolean,
	) {
		const element = findNode(link);
		if (element) {
			const { top, left } = element.getBoundingClientRect();
			const index = Date.now() + Math.ceil(Math.random() * 100) + link;
			const div = {
				block: child,
				style: { top: top - 25, left: left - 25 },
				removeItem: () => {
					remove({ key: link, url, value: child });
				},
				saveItem: (str: string) => save(str),
				isAdmin,
			};
			const newSnack = { ...div, index };
			this.comments = [...this.comments, newSnack];
		}
	}

	render(
		chord: string,
		child: any,
		link: string,
		remove: (item: any) => void,
		save: (str: string) => void,
		isAdmin: boolean,
	) {
		this.createSnack(chord, child, link, remove, save, isAdmin);
		this.init();
		this.createJSX();
	}
}
export default new Comment();
